export enum ROLES {
  CR121701 = 'CR121701',
  CR121699 = 'CR121699',
  CR121687 = 'CR121687',
  CR121700 = 'CR121700',
  CR121702 = 'CR121702',
  CR121688 = 'CR121688',

  // fake pro certifikaty
  CR821688 = 'CR821688',
}
